var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftPlanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3984_11038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25809 15.7412C7.22488 16.7744 5.54971 16.7744 4.5165 15.7412L0.774909 11.9996C-0.258303 10.9664 -0.258303 9.29129 0.774908 8.25809L4.5165 4.51655C5.54971 3.48335 7.22488 3.48335 8.25809 4.51655L11.9997 8.2581C13.0329 9.29129 13.0329 10.9664 11.9997 11.9996L8.25809 15.7412Z",
    fill: "url(#paint0_linear_3984_11038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25809 15.7412C7.22488 16.7744 5.54971 16.7744 4.5165 15.7412L0.774909 11.9996C-0.258303 10.9664 -0.258303 9.29129 0.774908 8.25809L4.5165 4.51655C5.54971 3.48335 7.22488 3.48335 8.25809 4.51655L11.9997 8.2581C13.0329 9.29129 13.0329 10.9664 11.9997 11.9996L8.25809 15.7412Z",
    fill: "url(#paint1_linear_3984_11038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.774857 11.9999C1.80809 13.0331 3.48331 13.0331 4.51655 11.9999L15.7417 0.774926C16.7749 -0.258304 18.4501 -0.258309 19.4834 0.774914L23.225 4.51655C24.2583 5.54977 24.2583 7.22496 23.225 8.25819L11.9999 19.4832C10.9667 20.5164 9.29146 20.5164 8.25822 19.4832L0.774857 11.9999Z",
    fill: "url(#paint2_linear_3984_11038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.774857 11.9999C1.80809 13.0331 3.48331 13.0331 4.51655 11.9999L15.7417 0.774926C16.7749 -0.258304 18.4501 -0.258309 19.4834 0.774914L23.225 4.51655C24.2583 5.54977 24.2583 7.22496 23.225 8.25819L11.9999 19.4832C10.9667 20.5164 9.29146 20.5164 8.25822 19.4832L0.774857 11.9999Z",
    fill: "url(#paint3_linear_3984_11038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51642 15.7413C5.54966 16.7746 7.22487 16.7746 8.25812 15.7413L15.7415 8.25803C16.7748 7.2248 18.45 7.2248 19.4832 8.25803L23.2249 11.9997C24.2582 13.0329 24.2582 14.7081 23.2249 15.7413L15.7415 23.2246C14.7083 24.2579 13.033 24.2579 11.9998 23.2246L4.51642 15.7413Z",
    fill: "url(#paint4_linear_3984_11038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51642 15.7413C5.54966 16.7746 7.22487 16.7746 8.25812 15.7413L15.7415 8.25803C16.7748 7.2248 18.45 7.2248 19.4832 8.25803L23.2249 11.9997C24.2582 13.0329 24.2582 14.7081 23.2249 15.7413L15.7415 23.2246C14.7083 24.2579 13.033 24.2579 11.9998 23.2246L4.51642 15.7413Z",
    fill: "url(#paint5_linear_3984_11038)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3984_11038",
    x1: 6.38724,
    y1: 3.74167,
    x2: 2.15779,
    y2: 12.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8752E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3984_11038",
    x1: 8.38032,
    y1: 11.0696,
    x2: 4.94062,
    y2: 7.69244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12172,
    stopColor: "#3D0D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7034B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3984_11038",
    x1: 18.3701,
    y1: -0.0000333385,
    x2: 9.85717,
    y2: 20.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB45E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C0F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3984_11038",
    x1: 18.3701,
    y1: -0.0000333385,
    x2: 9.85717,
    y2: 20.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB45E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677403,
    stopColor: "#A829AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F28B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3984_11038",
    x1: 18.0002,
    y1: 7.49958,
    x2: 14.0004,
    y2: 23.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00479E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3984_11038",
    x1: 18.2164,
    y1: 7.92626,
    x2: 10.5237,
    y2: 22.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A40D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3984_11038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftPlanner);
export default __webpack_public_path__ + "static/media/microsoft-planner.b31f0c5952ce5aec2bf9618881b3fe56.svg";
export { ForwardRef as ReactComponent };